import { Switch } from '@material-ui/core';
import React from 'react';

import { IModelBase } from '~/src/dash/components/model';

export interface IModelSwitchProps {
  model: IModelBase;
  onChange: (model: IModelBase, checked: boolean) => void;
  checked: boolean;
  disabled?: boolean;
  name?: string;
}

export function ModelSwitchView({ model, checked, onChange, disabled }: IModelSwitchProps) {
  return (
    <Switch
      checked={checked}
      onChange={({ currentTarget }: React.ChangeEvent<HTMLInputElement>) => {
        onChange(model, currentTarget.checked);
      }}
      value={model.ID}
      color='primary'
      disabled={disabled}
    />
  );
}
